import React, { useState, useEffect } from "react"; 
import { Typography, Descriptions, Button, Card } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import Pageloader from "../../../../components/loader";
import TageComponents from "../../../../components/tageComponents";
import { useNavigate, useParams } from "react-router-dom";
import * as notificationAction from "../../../../redux/actions/notification.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { Title, Text } = Typography;
const pageName = "Notification";
const pageLink = "notification";

const NotificationView = (props) => {
  const params = useParams();
  const { postid } = params;
  const navigate = useNavigate();
  const [postData, setPostData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (postid){
      ForSingleDataEdit()
    }
  }, [postid])
  const ForSingleDataEdit = async () => {
    try {
      setLoading(true);
      await props.notificationAction.singleNotificationsAction(postid);
    } catch (e) {} finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (props.notificationView){
      setPostData(props.notificationView)
    }
  }, [props.notificationView])

  return (
    <div className="page-content">
      <div className="page-content-header">
        <Title level={2}>{`${pageName} View`}</Title>
        <div>
          <Button onClick={() => navigate(`/${pageLink}`)}><RollbackOutlined /></Button>
        </div>
      </div>
      <div className="p-content">
        <div className="row">
          <div className="col-md-6">
            {loading ? <Pageloader/>:<>
              <Title level={2} className="mb-15">Name: {postData?.title||"-"}</Title>
              <Descriptions style={{ marginBottom: "35px" }} className="listLabelBold">
                <Descriptions.Item label="Description" span={3}>{postData?.description||"-"}</Descriptions.Item>
                <Descriptions.Item label="Batch" span={3}><TageComponents tagArray={postData?.batch}/></Descriptions.Item>
                <Descriptions.Item label="Rider" span={3}><TageComponents tagArray={postData?.rider}/></Descriptions.Item>
                <Descriptions.Item label="City" span={3}><TageComponents tagArray={postData?.city}/></Descriptions.Item>
                <Descriptions.Item label="Store" span={3}><TageComponents tagArray={postData?.store}/></Descriptions.Item>
                <Descriptions.Item label="Category" span={3}><TageComponents tagArray={postData?.category} tagKey={"title"}/></Descriptions.Item>
              </Descriptions>
              <Card title="Content">
                {postData?.content ? <div dangerouslySetInnerHTML={{__html: postData?.content}}></div> : "-"}
              </Card>
            </>} 
          </div>
        </div>
      </div>
    </div>
  );
};


const mapStateToProps = (state) => {
  return {
    notificationView: state.NotificationReducer.notificationView,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    notificationAction: bindActionCreators(notificationAction, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationView);
